<style lang="scss">
</style>

<template>
    <div class="popup">
        <div class="popup-header">
            <p class="mb-0 fs-17 fw-b">
                <i class="fal fa-exclamation-triangle mr-8"></i>
                {{ title || $t(`${$options.name}.title`) }}
            </p>
            <div class="close" @click="close()"></div>
        </div>
        <div class="popup-content fs-17 h-auto">
            <el-form class="col-12" @submit="submit()" :error="server_error" :loading="loading" :success="success" :button-text="`${$options.name}.button`">
                {{message || $t(`${$options.name}.message`) }}
                <template #footerLeft>
                    <span class="btn btn-outline-primary ml-auto" @click="close()">{{ $t('general.cancel') }}</span>
                </template>
            </el-form>
        </div>
    </div>
</template>

<script>
import HasForm from '@/components/forms/has-form';

export default {
    name: 'popups.general.confirm',

    mixins: [HasForm],

    components: {
        ElForm: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElForm"),
    },

    props: {
        confirmCallback: {
            type: Function,
            required: true,
        },
        cancelCallback: {
            type: Function
        },
        title: {
            type: String
        },
        message: {
            type: String,
        }
    },

    data() {
        return {
            password: '',
        }
    },

    methods: {
        submit() {
            this.confirmCallback()
        },
        close() {
            if (this.cancelCallback) {
                this.cancelCallback()
            }
            this.$emit('close')
        }
    },
}
</script>